import { Text } from 'shared/ui/common/Text'
import { Button } from 'shared/ui/controls/Button'
import { AddressIcon } from 'modules/blockChain/ui/AddressIcon'
import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { trimMiddleString } from 'shared/utils/trimMiddleString'

import { ReactComponent as CrossSVG } from 'assets/close.svg'

import s from './NFCSFormPartAddress.module.scss'

type Props = {
  address: string
  index: number
  description?: React.ReactNode
  onRemove?: () => void
}

export function NFCSFormPartAddress({
  index,
  address,
  description,
  onRemove,
}: Props) {
  const { walletAddress } = useWeb3()
  return (
    <div className={s.addressRow}>
      <div className={s.addressRowHeader}>
        <div className={s.addressRowHeaderCenter}>
          <AddressIcon address={address} className={s.addressIcon} />
          <Text color="secondary" size={16}>
            Account {index + 1}
          </Text>
          &nbsp;
          <Text size={16} className={s.accountAddress}>
            {trimMiddleString(address, 4)}
          </Text>
        </div>
        {onRemove && (
          <Button
            size={24}
            fashion="glass-matte"
            isSquare
            className={s.addressControl}
            onClick={onRemove}
          >
            <CrossSVG />
          </Button>
        )}
      </div>

      {description || address === walletAddress ? (
        <Text
          size={16}
          weight={500}
          color="secondary"
          isCentered
          className={s.description}
        >
          {description}
          {address === walletAddress && (
            <span>
              You are <b>connected</b> to this address now.
            </span>
          )}
        </Text>
      ) : null}
    </div>
  )
}
